import { Clock, Loader2 } from 'lucide-react';
import { formatCountdown, useCountdown } from '../sendHold';

/**
 * The clock on a completed inspection whose report is on its ten-minute hold
 * (JIM-1003-05, Jim 2026-10-03: "a little clock type thing on the line of the
 * inspection... if that timer's on there, that means it hadn't been sent
 * yet"). Counts down to the send, then reads "Sending".
 */
export function SendClock({ sendsAt }: { sendsAt: string }) {
  const left = useCountdown(sendsAt);
  return (
    <span
      data-testid="send-clock"
      title="This report has not been emailed to the client yet"
      className="inline-flex items-center gap-1 text-xs font-semibold text-sky-700 dark:text-sky-300 tabular-nums flex-shrink-0"
    >
      {left > 0 ? (
        <>
          <Clock className="w-3.5 h-3.5" />
          Sends in {formatCountdown(left)}
        </>
      ) : (
        <>
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
          Sending
        </>
      )}
    </span>
  );
}
